const userKey = "ip-my-usr";
const tokenKey = "ip-my-tkn";
const expKey = "ip-my-exp";

export default {
  namespaced: true,
  state: {
    user: localStorage.getItem(userKey) ?? {},
    token: localStorage.getItem(tokenKey),
    exp: localStorage.getItem(expKey),
  },
  getters: {
    getUser: (state) => {
      return state.user;
    },
    getToken: (state) => {
      return state.token;
    },
  },
  mutations: {
    set_user: (state, payload) => {
      state.user = payload.user;
      localStorage.setItem(userKey, payload.user);
    },
    set_token: (state, payload) => {
      state.token = payload.token;
      localStorage.setItem(tokenKey, payload.token);
    },
    clear: (state) => {
      state.user = null;
      state.token = null;
      localStorage.removeItem(userKey);
      localStorage.removeItem(tokenKey);
      localStorage.removeItem(expKey);
    },
    set_exp: (state, payload) => {
      localStorage.setItem(expKey, payload);
      state.exp = payload;
    },
  },
  actions: {
    login: ({ dispatch, commit }, payload) => {
      return new Promise((resolve, reject) => {
        dispatch("api/login", payload, { root: true })
          .then((resp) => {
            const user = resp.data;
            commit("set_token", { token: user.token });
            var decoded = JSON.parse(atob(user.token.split(".")[1]));
            commit("set_exp", decoded.exp * 1000);
            commit("set_user", {
              user: { username: user.userName, color: user.hexColor },
            });
            resolve();
          })
          .catch((err) => {
            dispatch("logout");
            reject(err);
          });
      });
    },
    register: ({ dispatch, commit }, payload) => {
      return new Promise((resolve, reject) => {
        dispatch("api/register", payload, { root: true })
          .then((resp) => {
            const user = resp.data;
            commit("set_token", { token: user.token });
            var decoded = JSON.parse(atob(user.token.split(".")[1]));
            commit("set_exp", decoded.exp * 1000);
            commit("set_user", {
              user: { username: user.userName, color: user.hexColor },
            });
            resolve();
          })
          .catch((err) => {
            dispatch("logout");
            reject(err);
          });
      });
    },
    logout: ({ commit }) => {
      commit("clear");
    },
  },
};
